"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButtton = exports.StyledForm = exports.StyledArrowIcon = exports.PolicyText = exports.DocumentInfoWrapper = exports.ConditionsInfoWrapper = exports.ConditionTitle = exports.CollapseBox = exports.BackButtton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const StyledForm = exports.StyledForm = (0, _mui.styled)('form')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  marginTop: theme.spacing(8)
}));
const SubmitButtton = exports.SubmitButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(3),
  order: 50
}));
const BackButtton = exports.BackButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: '60px',
  marginTop: theme.spacing(2)
}));
const StyledArrowIcon = exports.StyledArrowIcon = (0, _mui.styled)(_icons.ArrowLeftThin)(({
  theme
}) => ({
  marginRight: theme.spacing(1)
}));
const DocumentInfoWrapper = exports.DocumentInfoWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  alignItems: 'flex-start'
}));
const ConditionsInfoWrapper = exports.ConditionsInfoWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: theme.spacing(2, 0),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(6)
  }
}));
const ConditionTitle = exports.ConditionTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(4)
}));
const PolicyText = exports.PolicyText = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(3),
  textAlign: 'left'
}));
const CollapseBox = exports.CollapseBox = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  fontWeight: 'bold',
  cursor: 'pointer'
}));